import {
  Block,
  Image,
  SvgIcon,
  Touchable,
  Typography,
  palette,
  spacing,
  useSafeAreaInsets,
} from "@stepapp/ui";
import { useLocalSearchParams, useRouter } from "expo-router";
import { StatusBar } from "expo-status-bar";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { walkthrough1, walkthrough2, walkthrough3 } from "../../src/assets/images";

const WelcomeScreen = () => {
  const { t } = useTranslation();
  const { step } = useLocalSearchParams();
  const startStep = Number(step) || 0;
  const { back } = useRouter();

  const { top } = useSafeAreaInsets();

  const goBack = useCallback(() => {
    back();
  }, [back]);

  return (
    <Block style={styles.container}>
      <StatusBar hidden />

      {startStep !== 0 && (
        <Touchable style={styles.backIconContainer} onPress={goBack}>
          <Block
            alignCenter
            justifyCenter
            style={[styles.backIcon, { marginTop: spacing.unit * 2 + top }]}
          >
            <SvgIcon color={palette.common.black} name={"chevron-left"} size={28} />
          </Block>
        </Touchable>
      )}

      <Image
        contentFit="cover"
        height="65%"
        source={startStep === 0 ? walkthrough1 : startStep === 1 ? walkthrough2 : walkthrough3}
        style={styles.image}
        width="100%"
      />

      <Block justifyEnd flex={1} paddingBottom={2}>
        {startStep === 0 && (
          <Block style={styles.content}>
            <Typography center variant="newH1">
              {t("screens.welcome.orderCleaningTitle")}
            </Typography>
            <Block paddingTop={1}>
              <Typography center variant="body">
                {t("screens.welcome.orderCleaningDescription")}
              </Typography>
            </Block>
          </Block>
        )}
        {startStep === 1 && (
          <Block style={styles.content}>
            <Typography center variant="newH1">
              {t("screens.welcome.trustedTeamTitle")}
            </Typography>
            <Block paddingTop={1}>
              <Typography center variant="body">
                {t("screens.welcome.trustedTeamDescription")}
              </Typography>
            </Block>
          </Block>
        )}
        {startStep === 2 && (
          <Block style={styles.content}>
            <Typography center variant="newH1">
              {t("screens.welcome.customerSupportTitle")}
            </Typography>
            <Block paddingTop={1}>
              <Typography center variant="body">
                {t("screens.welcome.customerSupportDescription")}
              </Typography>
            </Block>
          </Block>
        )}
      </Block>
    </Block>
  );
};

export default WelcomeScreen;

const styles = StyleSheet.create({
  backIcon: {
    backgroundColor: palette.secondary.grey,
    borderRadius: spacing.unit * 2.5,
    height: spacing.unit * 5,
    width: spacing.unit * 5,
    marginLeft: spacing.unit * 2.5,
  },
  backIconContainer: {
    zIndex: 5,
  },
  container: {
    flex: 1,
  },
  content: {
    backgroundColor: palette.common.grayBackground,
    padding: spacing.unit * 2.5,
  },
  image: {
    position: "absolute",
  },
});
